export default __webpack_public_path__ + "static/plp--story-3-58b3154c846b89bd387b98abbcbedca9.jpg";